import { Link } from "gatsby"
import React from "react"
import styled from "styled-components"

const LogoContainer = styled.div`
  display: flex;
  margin-top: 20px;
  text-decoration: none;

  @media only screen and (max-width: 736px) {
    flex-direction: column;
  }
`

const Title = styled.h1`
  font-size: 40px;
  margin-bottom: 0;
  text-decoration: none;
`

const Subtitle = styled.h5`
  text-decoration: none;
`

const Disclaimer = styled.h6`
  text-decoration: none;
`

export default function Logo() {
  return (
    <Link to="/">
      <LogoContainer>
        <Title>Исчезающая Калуга</Title>
        <Subtitle>онлайн-выставка</Subtitle>
      </LogoContainer>
      {/* <Disclaimer>Калужское отделение ВТОО "Союз художников России"</Disclaimer> */}
    </Link>
  )
}
